/**
 * Нормализация пригласительного токена из deep-link.
 *
 * Telegram отдаёт `start_param` ровно тем, что стоит в ссылке после
 * `?startapp=`. Бэкенд генерирует ссылки вида `?startapp=inv_<hex>`, но в
 * старых данных/ссылках мог встречаться префикс `invite_` или голый hex.
 * Приводим всё к каноническому `inv_<hex>`, который понимает бэкенд.
 *
 * Возвращает null, если параметр не похож на приглашение (в т.ч. пустое ядро).
 */
export function normalizeInviteToken(raw?: string | null): string | null {
  if (typeof raw !== 'string') return null;
  let core = raw.trim();
  if (!core) return null;
  if (core.startsWith('invite_')) core = core.slice('invite_'.length);
  else if (core.startsWith('inv_')) core = core.slice('inv_'.length);
  // Токен — это hex; пустое или не-hex ядро отбрасываем.
  if (!/^[0-9a-fA-F]+$/.test(core)) return null;
  return `inv_${core}`;
}

/**
 * Нужно ли показать онбординг вместо обычного приложения.
 *
 * Пользователь, пришедший по пригласительной ссылке, ещё «не проходил
 * онбординг»: он новый, и в базе у него `onboarding_completed=false`. Если
 * отдать его на экран выбора «Я работаю один / У меня есть команда», баннер
 * приглашения не показывается (он живёт внутри основного приложения) и
 * приглашение теряется — человек не попадает в команду школы.
 *
 * Поэтому приглашение важнее онбординга: пока токен не обработан или не
 * отклонён, онбординг не показываем.
 */
export function shouldShowOnboarding(
  needsOnboarding: boolean | undefined | null,
  inviteToken: string | null,
): boolean {
  return !!needsOnboarding && !inviteToken;
}
